import { initialFlagFilters } from '../../constants/constants';

const INITIAL_STATE = {
  pdfViewerDocumentId: null,
  expand: false,
  filterByThumbs: false,
  allFlagsByDocument: [],
  pdfFlags: [],
  myFilter: true,
  sharedFilter: 1,
  aiFilter: false,
  filters: false,
  typeFilter: null,
  flagFilters: initialFlagFilters,
  isFlagCreatedByPlayer: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_PDF_VIEWER_DOCUMENT_ID': {
      return { ...state, pdfViewerDocumentId: action.payload };
    }
    case 'SET_EXPAND': {
      return { ...state, expand: action.payload };
    }
    case 'SET_FILTER_BY_THUMBS': {
      //filter by thumbs
      return { ...state, filterByThumbs: action.payload };
    }
    case 'FETCH_ALL_FLAGS_BY_DOCUMENT_URL': {
      return { ...state, allFlagsByDocument: action.payload };
    }
    case 'SET_PDF_FLAGS': {
      return { ...state, pdfFlags: action.payload };
    }
    case 'SET_MY_FILTER': {
      //my flags
      return { ...state, myFilter: action.payload };
    }
    case 'SET_SHARED_FILTER': {
      //shared flags
      return { ...state, sharedFilter: action.payload };
    }
    case 'SET_AI_FILTER': {
      //ai flags
      return { ...state, aiFilter: action.payload };
    }
    case 'SET_FILTERS': {
      //filter from the box
      return { ...state, filters: action.payload };
    }
    case 'SET_TYPE_FILTER': {
      //my or shared
      return { ...state, typeFilter: action.payload };
    }
    case 'SET_FLAG_FILTERS': {
      return {
        ...state,
        flagFilters: { ...state.flagFilters, ...action.payload }
      };
    }
    case 'CREATE_FLAG_FROM_PLAYER': {
      return { ...state, isFlagCreatedByPlayer: action.payload };
    }
    case 'RESET_FLAG_CREATION_STATUS': {
      return { ...state, isFlagCreatedByPlayer: action.payload };
    }
    default:
      return state;
  }
}
